import type { JSX } from 'react'
import { FoxIconRuler, FoxIconSquareFoot } from 'shared/src/components/font/FoxIcon'
import { UnitSystem, useMeasurementContext } from 'shared/src/context/MeasurementContext'
import { T } from 'shared/src/util/translation'
import 'whats_inside/src/pages/deviceData/components/unitSwitcher/UnitSwitcher.scss'

type MeasurementSystemButtonProps = {
  text: string
  newSystem: UnitSystem
  cypressId: string
  caption: string
  icon: JSX.Element
}

const MeasurementSystemButton = (props: MeasurementSystemButtonProps) => {
  const { icon, text, cypressId, newSystem, caption } = props
  const { currentUnitSystemType, setUnitSystem } = useMeasurementContext()

  const isSelected = newSystem === currentUnitSystemType

  const handleClick = () => {
    setUnitSystem(newSystem)
  }

  return (
    <button
      type='button'
      data-cy={cypressId}
      className={`measurement-button ${isSelected ? 'selected' : ''}`}
      onClick={handleClick}
    >
      <span className='icon'>{icon}</span>
      <span className='label'>{text}</span>
      <span className='caption'>{caption}</span>
    </button>
  )
}

export const UnitSwitcher = () => {
  return (
    <div className='unit-switcher'>
      <p className='title'>{T('measurement_system')}</p>
      <div className='button-container'>
        <MeasurementSystemButton
          cypressId='measurement-system-selector-metric'
          newSystem={UnitSystem.METRIC}
          text={T('measurement_system_metric')}
          caption={T('mm_abbr')}
          icon={<FoxIconRuler />}
        />
        <MeasurementSystemButton
          cypressId='measurement-system-selector-us-customary'
          newSystem={UnitSystem.US_CUSTOMARY}
          text={T('measurement_system_us_customary')}
          caption={T('inch')}
          icon={<FoxIconSquareFoot />}
        />
      </div>
    </div>
  )
}
